import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// New Site Components
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Solutions from "@/components/site/Solutions";
import Speaking from "@/components/site/Speaking";
import Shop from "@/components/site/Shop";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

// Flyers (keep for /flyers route)
import SocialMediaFlyers from "@/components/flyer/SocialMediaFlyers";

// Main Site
const MainSite = () => (
  <>
    <Navigation />
    <Hero />
    <About />
    <Solutions />
    <Speaking />
    <Shop />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <div className="min-h-screen bg-background font-body">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/flyers" element={<SocialMediaFlyers />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
